var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('eagle-form',{attrs:{"form-key":_vm.formKey},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('liff-member-block',{attrs:{"members":_vm.members,"role":"store","showAction":false}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }